import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../Components/Banner/Banner'
import Services from '../Components/Services'
import ServicesCategories from '../Components/Services'
import Slider from '../Components/Slider'
import WhatWeDo from '../Components/WhatWeDo'
import AboutSection from '../Components/AboutSection'
import Partners from '../Components/Partners'
import Industries from '../Components/Industries'
import Newsletter from '../Components/Newsletter'

function Home() {
    return (
        <>
        <Helmet>
            <title>Fusion Hub – Expert Engineering, IT & Business Services</title>
            <meta name="description" content="Fusion Hub offers comprehensive solutions in engineering solution, digital & IT services, HR, business operations, and more. Enhance your business with expert services." />
        </Helmet>
            <Banner />
            {/* <Slider /> */}
            <WhatWeDo />
            <AboutSection />
            {/* <Partners /> */}
            <ServicesCategories />
            <Industries />
            <Newsletter />
        </>
    )
}

export default Home